import React, { PureComponent } from 'react';

import { Dropdown } from 'components/ClubComponents';
import { isNil } from 'helpers/Array';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';

const OMITTED_PROPS = ['toogleModalMacro', 'macro', 'modal'];

class NotificationMacroDropdownItem extends PureComponent {
  static propTypes = {
    macro: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      content: PropTypes.string.isRequired
    }).isRequired,
    modal: PropTypes.shape({
      open: PropTypes.bool
    }).isRequired,
    toogleModalMacro: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const { macro } = props;

    this.handleClick = this.handleClick.bind(this);

    this.item = {
      id: macro.id,
      label: macro.content,
      onClick: this.handleClick
    };
  }

  handleClick() {
    const { toogleModalMacro, modal, macro } = this.props;

    if (isNil(toogleModalMacro)) {
      return;
    }

    toogleModalMacro(modal.open, macro.id);
  }

  render() {
    const { macro, ...others } = this.props;

    return (
      <Dropdown.Item
        {...omit(others, OMITTED_PROPS)}
        id={macro.id}
        item={this.item}
      />
    );
  }
}

export default NotificationMacroDropdownItem;
